import {isApiException} from '@dms/api/utils';

import {ApiError, isFetchBaseQueryError, Nullish} from 'shared/web';

/**
 * Refusal code of reserve, rent and vehicle change when a rental vehicle block covers
 * the planned period (backend `VEHICLE_BLOCKED`).
 */
const VEHICLE_BLOCKED_ERROR_CODE = 'DMS-CR-RO-0030';

/**
 * Returns the already-translated server message of a vehicle-blocked refusal, or nothing
 * for any other error. The error body carries no structured detail beyond the message.
 */
export function getVehicleBlockedErrorMessage(error: ApiError): string | Nullish {
  if (!isFetchBaseQueryError(error) || !isApiException(error.data)) {
    return null;
  }

  return error.data.errors.find((apiError) => apiError.code === VEHICLE_BLOCKED_ERROR_CODE)
    ?.message;
}
